import { IPagination } from 'app/types/common';

export interface IAdminsState {
  readonly adminsById?: any;
  readonly adminIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectAdminLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddAdmin?: boolean;
  readonly backendErrors?: any;
  readonly currentAdminId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly requestedData?: any;
  readonly pagination?: IPagination;
}

export interface IAdminsSelector extends IAdminsState {
  readonly currentAdmin?: any;
  readonly getAdminsFilteredByTagInSelectFormat?: any;
  readonly adminsByIdInSelectFormat?: any;
}

export enum AdminsActionTypes {
  GET_ALL_ADMINS_REQUESTED = 'redux-app/admins/GET_ALL_ADMINS_REQUESTED',
  GET_ALL_ADMINS_PENDING = 'redux-app/admins/GET_ALL_ADMINS_PENDING',
  GET_ALL_ADMINS_SUCCESS = 'redux-app/admins/GET_ALL_ADMINS_SUCCESS',
  GET_ALL_ADMINS_FAIL = 'redux-app/admins/GET_ALL_ADMINS_FAIL',
  GET_ADMIN_REQUESTED = 'redux-app/admins/GET_ADMIN_REQUESTED',
  GET_ADMIN_PENDING = 'redux-app/admins/GET_ADMIN_PENDING',
  GET_ADMIN_SUCCESS = 'redux-app/admins/GET_ADMIN_SUCCESS',
  GET_ADMIN_FAIL = 'redux-app/admins/GET_ADMIN_FAIL',
  UPDATE_ADMIN_REQUESTED = 'redux-app/admins/UPDATE_ADMIN_REQUESTED',
  UPDATE_ADMIN_PENDING = 'redux-app/admins/UPDATE_ADMIN_PENDING',
  UPDATE_ADMIN_SUCCESS = 'redux-app/admins/UPDATE_ADMIN_SUCCESS',
  UPDATE_ADMIN_FAIL = 'redux-app/admins/UPDATE_ADMIN_FAIL',
  CREATE_ADMIN_REQUESTED = 'redux-app/admins/CREATE_ADMIN_REQUESTED',
  CREATE_ADMIN_PENDING = 'redux-app/admins/CREATE_ADMIN_PENDING',
  CREATE_ADMIN_SUCCESS = 'redux-app/admins/CREATE_ADMIN_SUCCESS',
  CREATE_ADMIN_FAIL = 'redux-app/admins/CREATE_ADMIN_FAIL',
  DELETE_ADMIN_REQUESTED = 'redux-app/admins/DELETE_ADMIN_REQUESTED',
  DELETE_ADMIN_PENDING = 'redux-app/admins/DELETE_ADMIN_PENDING',
  DELETE_ADMIN_SUCCESS = 'redux-app/admins/DELETE_ADMIN_SUCCESS',
  DELETE_ADMIN_FAIL = 'redux-app/admins/DELETE_ADMIN_FAIL',
  SELECT_ADMIN_REQUESTED = 'redux-app/admins/SELECT_ADMIN_REQUESTED'
}

export default null;
